import { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormHelperText,
  Grid,
  IconButton,
  Typography,
  styled,
} from "@mui/material";
import Footer from "components/common/dialog/Footer";
import Header from "components/common/dialog/Header";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ResetPassword } from "redux/slice/session/auth.slice";
import { assetsObj } from "services/images";
import * as Yup from "yup";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { pathApp } from "services/utiles";

const WhiteBorderTextField = styled("input")({
  width: "100%",
  padding: "12px 14px",
  backgroundColor: "transparent",
  border: "1px solid white",
  borderRadius: "6px",
  color: "white",
  "&:focus": {
    borderColor: "#ffffff",
  },
  "&::placeholder": {
    color: "white",
  },
  "&:focus-visible ": {
    outline: "1px solid white",
  },
});

const TrialReset = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const handleTogglePasswordVisibility1 = () => {
    setShowPassword1(!showPassword1);
  };

  const handleTogglePasswordVisibility2 = () => {
    setShowPassword2(!showPassword2);
  };

  const formik = useFormik({
    initialValues: {
      new_password: "",
      confirm_password: "",
    },
    enableReinitialize: true,

    validationSchema: Yup.object({
      new_password: Yup.string()
        .min(8, "Must contain 8 characters")

        .required("Password is required"),
      confirm_password: Yup.string()
        .required("Confirm password is required")
        .oneOf(
          [Yup.ref("new_password"), null],
          "Confirm password does not matched "
        ),
    }),

    onSubmit: (value) => {
      value["type"] = 1;
      let email = localStorage.getItem("email");
      value["email"] = email;

      setLoading(true);
      dispatch(ResetPassword(value))
        .unwrap()
        .then((res) => {
          setLoading(false);
          if (res?.success) {
            navigate(`${pathApp}trial-login`);
            localStorage.setItem("email", value.email);
            toast.success("Password successfully updated");
            // sessionStorage.setItem("token", res?.token);
          }
        });
    },
  });

  return (
    <>
      <Box
        sx={{
          height: "100%",
          color: "white",
          overflow: "auto",
          backgroundImage: `url(${assetsObj.gradientImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Header />
        <Box
          component="section"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            marginTop:"120px",
            maxWidth: "auto",
          }}
        >
          <Box maxWidth="md">
            <form onSubmit={formik.handleSubmit}>
              <Grid
                item
                xs={11}
                md={8}
                container
                justifyContent="center"
                margin="auto"
                alignItems="center"
                sx={{
                  "@media (max-width: 599px)": {
                    marginBottom: 12,
                  },
                }}
              >
                <Grid item xs={12}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 400,
                      marginBottom: 4,
                      textAlign: "center",
                      color: "#fff",
                    }}
                    gutterBottom
                  >
                    In with the new
                  </Typography>
                </Grid>

                <Grid item xs={12} sx={{ marginBottom: 2 }}>
                  <Box sx={{ position: "relative" }}>
                    <WhiteBorderTextField
                      sx={{ paddingRight: 4, mb: 0 }}
                      placeholder="New Password"
                      type={showPassword1 ? "text" : "password"}
                      name="new_password"
                      onChange={formik.handleChange}
                      value={formik.values.new_password}
                    />
                    <IconButton
                      onClick={handleTogglePasswordVisibility1}
                      sx={{
                        color: "white",
                        position: "absolute",
                        right: "0px",
                        top: "50%",
                        transform: "translate(-0%, -50%)",
                      }}
                    >
                      {showPassword1 ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </Box>
                  {formik.errors.new_password && (
                    <FormHelperText error>
                      {formik.errors.new_password}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item xs={12} sx={{ marginBottom: 2 }}>
                  <Box sx={{ position: "relative" }}>
                    <WhiteBorderTextField
                      sx={{ paddingRight: 4, mb: 0 }}
                      placeholder="Confirm New Password"
                      type={showPassword2 ? "text" : "password"}
                      name="confirm_password"
                      onChange={formik.handleChange}
                      value={formik.values.confirm_password}
                    />
                    <IconButton
                      onClick={handleTogglePasswordVisibility2}
                      sx={{
                        color: "white",
                        position: "absolute",
                        right: "0px",
                        top: "50%",
                        transform: "translate(-0%, -50%)",
                      }}
                    >
                      {showPassword2 ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </Box>
                  {formik.errors.confirm_password && (
                    <FormHelperText error>
                      {formik.errors.confirm_password}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Button
                    variant="contained"
                    // onClick={handleSignup}
                    sx={{
                      borderRadius: "60px",
                      width: "50%",
                      background: "transparent",
                      //   marginBottom: 2,
                      border: "1px solid white",
                      "&:hover": {
                        background: "white",
                        color: "black",
                        transition: "0.2s ease-in-out",
                      },
                      mx: "auto",
                    }}
                    type="submit"
                  >
                    {loading ? (
                      <CircularProgress size={22} color="secondary" />
                    ) : (
                      "Done"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Box>
        <Footer />
      </Box>
    </>
  );
};

export default TrialReset;
